<div class="wrapper">
  @for (addressType of typeProps; track addressType) {
    <div class="address">
      <label class="form-control__label">
        <p class="t-data t-bold t-capitalize">{{ addressType }}</p>
      </label>
      <div class="basic-address__row">
        @for (
          addressConfig of addressLine1[addressType] | keyvalue;
          track addressConfig
        ) {
          <form-control
            class="basic-address__control"
            [control]="
              formGroup.get(config.prop).get(addressType).get(addressConfig.key)
            "
            [config]="addressConfig.value"
            direction="grouping"
          >
          </form-control>
        }
      </div>
      <div class="basic-address__row basic-address__row--2">
        @for (
          addressConfig of addressLine2[addressType] | keyvalue;
          track addressConfig
        ) {
          <form-control
            class="basic-address__control"
            [control]="
              formGroup.get(config.prop).get(addressType).get(addressConfig.key)
            "
            [config]="addressConfig.value"
            direction="grouping"
          >
          </form-control>
        }
      </div>
    </div>
  }
</div>
